"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const element_1 = require("../element");
const styled_components_1 = __importDefault(require("styled-components"));
const ImageTagStyled = styled_components_1.default.div `
	&.no-img {
		background: var(--color-silver, #f3f4f8);
		border-radius: 4px;
		flex-shrink: 0;
		width: 100px;
		height: 100px;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
	}
`;
const getFileExtension = fileName => {
    const parts = fileName.split('.');
    return parts.length > 1 ? parts[parts.length - 1] : '';
};
const ImageTag = react_1.default.memo(({ file }) => {
    const [hasError, setHasError] = (0, react_1.useState)(false);
    const handleError = () => {
        setHasError(true);
    };
    (0, react_1.useEffect)(() => {
        setHasError(false);
    }, [file]);
    const ext = (0, react_1.useMemo)(() => getFileExtension(file)?.toLowerCase(), [file]);
    return !hasError && ['jpg', 'jpeg', 'png', 'gif'].includes(ext) ? (react_1.default.createElement("img", { className: "img", src: file, alt: "", onError: handleError })) : (react_1.default.createElement(ImageTagStyled, { className: "no-img" },
        react_1.default.createElement(element_1.Icon, { icon: `no_${['pdf', 'zip'].includes(ext) ? getFileExtension(file) : 'image'}`, width: 50, height: 58 })));
});
exports.default = ImageTag;
